<template>
  <div>
    <el-form :inline="true" :model="query" class="query-form" size="small">
      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-edit"
          @click.native="handleForm(null, null)"
          >添加</el-button
        >
      </el-form-item>

      <el-form-item class="query-form-item" label="物流公司">
        <el-select
          v-model="query.expressid"
          placeholder="请选择物流公司"
          style="width:150px"
          @change="onSubmit"
          clearable
        >
          <el-option
            v-for="(item, index) in listExpress"
            :key="index"
            :label="item.expressname"
            :value="item.expressid"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item class="query-form-item">
        <el-input
          placeholder="分区名称/ID"
          v-model="query.subareatest"
          prefix-icon="el-icon-search"
          @keyup.enter.native="onSubmit"
          clearable
        >
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-refresh"
          @click="onRest"
        ></el-button>
        <el-button type="primary" icon="el-icon-search" @click="onSubmit"
          >查询</el-button
        >
      </el-form-item>
    </el-form>
    <!-- <el-scrollbar class="table-scrollbar" wrap-style="overflow-x: hidden;"> -->
    <el-table
      ref="multipleTable"
      v-loading="loading"
      :data="list"
      :header-cell-style="{ background: '#F4F4F5', color: '#606266' }"
      @selection-change="handleSelectionChange"
      border
    >
      <el-table-column
        label="选择"
        prop="orderid"
        type="selection"
        :show-overflow-tooltip="true"
        width="50"
        align="center"
      />
      <el-table-column label="分区ID" align="center" prop="subareauid" />
      <el-table-column label="物流公司" align="center" prop="expressname" />
      <el-table-column label="分区名称" align="center" prop="subareaname" />
      <el-table-column label="添加时间" align="center">
        <template slot-scope="scope">
          <i class="el-icon-time"></i>
          <span>{{
            scope.row.subareatime | formatDateStr("yyyy-MM-dd hh:mm:ss")
          }}</span>
        </template>
      </el-table-column>
      <el-table-column width="200" label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click.native="handleForm(scope.$index, scope.row)"
            >修改</el-button
          >
          <el-button
            type="danger"
            size="mini"
            @click.native="handleDel(scope.row.subareaid)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="left-container">
      <el-button type="danger" size="small" @click="delGroup()"
        >删除已选</el-button
      >
      <transition name="el-fade-in-linear">
        <el-button size="small" @click="toggleSelection()" v-show="cancelToggle"
          >取消选择</el-button
        >
      </transition>
    </div>
    <el-pagination
      class="pagination-container"
      background
      :current-page="query.currentPage"
      :page-size="query.pageSize"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      layout="total,sizes,prev, pager, next, jumper"
      :page-sizes="[10, 20, 30, 50]"
      :total="totalNumber"
    ></el-pagination>
    <!-- -增加 修改-->
    <el-dialog
      :visible.sync="formVisible"
      :before-close="hideForm"
      width="800px"
      top="5vh"
      v-dialogDrag
    >
      <el-form :model="formData" :rules="formRules" ref="dataForm">
        <el-form-item class="query-form-item" label="物流公司" prop="expressid">
          <el-select
            v-model="formData.expressid"
            placeholder="请选择物流公司"
            style="width:150px"
            clearable
          >
            <el-option
              v-for="(item, index) in listExpress"
              :key="index"
              :label="item.expressname"
              :value="item.expressid"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="分区名称:" prop="subareaname">
          <el-input
            style="width: 240px"
            v-model="formData.subareaname"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click.native="hideForm">取消</el-button>
        <el-button
          type="primary"
          @click.native="formSubmit()"
          :loading="formLoading"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getList,
  deleteSubarea,
  addSubarea,
  updateSubarea,
  getSubareaInfo,
  getExpress
} from "../../api/freight/subarea.js";
const formJson = {
  subareaid: "",
  subareaname: "",
  expressid: ""
};

export default {
  data() {
    var checkName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入分区名称"));
      } else {
        callback();
      }
    };
    var checkExpressid = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请选择物流公司"));
      } else {
        callback();
      }
    };

    return {
      subareaid: "",
      subareaname: "",
      subareatime: "",
      expressname: "",
      dialogVisible: false,
      cancelToggle: false,
      query: {
        subareaid: "",
        subareatest: "",
        expressid: "",
        currentPage: 1,
        pageSize: 10
      },
      list: [],
      totalNumber: 0,
      loading: true,
      index: null,
      formName: null,
      formLoading: false,
      formVisible: false,
      formInfo: false,
      formInput: false,
      formData: formJson,
      formAdd: formJson,
      formRules: {
        subareaname: [{ validator: checkName, trigger: "blur" }],
        expressid: [{ validator: checkExpressid, trigger: "blur" }]
      },
      multipleSelection: [], //多选集合
      listExpress: [] // 物流公司
    };
  },
  methods: {
    //加载物流公司
    getExpress() {
      getExpress()
        .then(response => {
          if (response.code) {
            this.$message.error(response.message);
          }

          this.listExpress = response.data || [];

          setTimeout(() => {
            this.loading = false;
          }, 0.3 * 1000);
        })
        .catch(() => {
          this.loading = false;
          this.listExpress = [];
        });
    },

    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    dateChange(val) {
      if (val == null) {
        this.query.startTime = "";
        this.query.endTime = "";
      } else {
        this.query.startTime = val[0];
        this.query.endTime = val[1];
      }
      this.getList();
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      if (val == "") {
        this.cancelToggle = false;
        return;
      }
      this.cancelToggle = true;
    },
    delGroup() {
      var ids = this.multipleSelection.map(item => item.subareaid).join(); //获取所有选中行的id组成的字符串，以逗号分隔
      if (ids == "") {
        this.$message({
          message: "请先选择",
          type: "warning"
        });
        return;
      }
      this.handleDel(ids);
    },
    onRest() {
      this.query = {
        currentPage: 1,
        pageSize: 10
      };
      this.getList();
    },
    onSubmit() {
      this.$router.push({
        path: "",
        query: this.query
      });
      this.getList();
    },
    handleCurrentChange(val) {
      this.query.currentPage = val;
      //scrollTo(0, 800);
      this.getList();
    },
    handleSizeChange(val) {
      this.query.pageSize = val;
      this.getList();
    },

    getList() {
      this.loading = true;
      getList(this.query)
        .then(response => {
          if (response.code) {
            this.$message.error(response.message);
          }

          this.list = response.data.list || [];
          this.totalNumber = response.data.totalNumber || 0;
          setTimeout(() => {
            this.loading = false;
          }, 0.3 * 1000);
        })
        .catch(() => {
          this.loading = false;
          this.list = [];
          this.totalNumber = 0;
        });
    },
    // 隐藏表单
    hideForm() {
      // 更改值
      this.formVisible = !this.formVisible;
      this.$refs["dataForm"].resetFields();

      // this.formData.expressid = "";
      // this.formData.subareaid = "";
      // this.formData.subareaname = "";
      // return true;
    },
    // 显示表单
    handleForm(index, row) {
      this.formData = Object.assign({}, formJson);
      if (row !== null) {
        this.formData = Object.assign({}, row);
      }
      this.getExpress();
      this.formVisible = true;
    },
    formSubmit() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          this.formLoading = true;
          let data = Object.assign({}, this.formData);
          updateSubarea(data).then(response => {
            this.formLoading = false;
            if (response.code) {
              this.$message.error(response.message);
              return false;
            }
            this.$message.success("操作成功");
            // 刷新表单
            //this.$refs.tinymce.clearContent();
            this.formVisible = false;
            this.$refs["dataForm"].resetFields();

            this.getList();
          });
        }
      });
    },

    formSub() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          this.formLoading = true;
          let data = Object.assign({}, this.formData);
          addSubarea(data).then(response => {
            this.formLoading = false;
            if (response.code) {
              this.$message.error(response.message);
              return false;
            }
            this.$message.success("操作成功");
            // 刷新表单
            this.$refs["dataForm"].resetFields();

            this.formInput = false;
            this.getList();
          });
        }
      });
    },
    // 删除
    handleDel(ids) {
      if (ids) {
        this.$confirm("确认要删除吗?", "提示", {
          type: "warning"
        })
          .then(() => {
            this.loading = true;
            var params = new URLSearchParams();
            params.append("ids", ids);
            deleteSubarea(params)
              .then(response => {
                this.loading = false;
                if (response.code) {
                  this.$message.error(response.message);
                  return false;
                }
                this.$message.success("删除成功");
                // 刷新数据
                //this.list.splice(index, 1);
                this.getList();
              })
              .catch(() => {
                this.loading = false;
              });
          })
          .catch(() => {});
      }
    }
  },
  created() {
    // 将参数拷贝进查询对象
    let query = this.$route.query;
    this.query = Object.assign(this.query, query);
    this.query.pageSize = parseInt(this.query.pageSize);
    // 加载表格数据
    this.getList();
    this.getExpress();
  }
};
</script>

<style type="text/scss" lang="scss">
body {
  margin: 0;
}
</style>
